import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.quotes.QuoteSupplierProvider.';
  public static readonly supplier = `${Id.prefix}supplier`;
}

export class LangQuoteSupplierProvider {
  private constructor() {}
  public static supplier(): string {
    return interpolate(Id.supplier);
  }
}

export class QuoteSupplierProviderModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.supplier, "{{glossary 'supplier'}}", 'Glossary term for supplier');
  }
}
